// Teknogirişim Rozeti künyesi — TEK kaynak (Hakkımızda sayfası buradan okur),
// `trademark.js` ile aynı desen.
//
// Kaynak belge: T.C. Sanayi ve Teknoloji Bakanlığı, Teknogirişim Rozeti — belge
// sıra no 2026-1747, onay tarihi 14.09.2026. 3 Temmuz 2025 tarih ve 32945 sayılı
// Teknoloji ve Yenilik Odaklı Girişimlerin Belirlenmesi ve Belgelendirilmesine
// Dair Yönetmeliğe göre onay tarihinden itibaren 3 yıl geçerlidir.
//
// BELGE SAYFADA GÖRÜNÜR (kullanıcı kararı 14.09.2026): rozet görsel olarak basılır.
// PDF indirme bağlantısı YOKTUR ve PDF `public/`e konmaz — ziyaretçinin belgeyi
// indirmesine gerek yok. Dosya adında numara/tarih yoktur (marka belgeleriyle aynı
// karar) — rozet yenilendiğinde yalnız bu dosya ve görsel değişir.
import { COMPANY_INFO } from './companyInfo';

export const TEKNOGIRISIM = {
  docNo: '2026-1747',
  term: '14.09.2026 – 14.09.2029',
  // Geçerliliğin son günü (İstanbul günü). Ertesi gün kart çizilmez: süresi
  // dolmuş bir rozeti göstermek yanıltıcı bir beyan olurdu.
  validUntil: '2029-09-14',
  issuer: 'T.C. Sanayi ve Teknoloji Bakanlığı',
  // Belge sahibi ŞİRKETİN KENDİSİDİR — unvanı ikinci kez yazmayalım.
  holder: COMPANY_INFO.legalName,
  image: '/teknogirisim-rozeti.jpg',
  // Görselin GERÇEK piksel ölçüsü (yatay A4, 150 dpi); <img>'e yazılır ki tarayıcı
  // yer ayırsın, yoksa belge yüklenirken sayfa zıplar.
  imageWidth: 1754,
  imageHeight: 1240,
};

// Etiket–değer sırası.
export const TEKNOGIRISIM_FACTS = [
  ['Belge Sıra No', TEKNOGIRISIM.docNo],
  ['Geçerlilik Süresi', TEKNOGIRISIM.term],
  ['Belge Sahibi', TEKNOGIRISIM.holder],
  ['Düzenleyen', TEKNOGIRISIM.issuer],
];

export const TEKNOGIRISIM_CAPTION = 'T.C. Sanayi ve Teknoloji Bakanlığı — Teknogirişim Rozeti';

export const TEKNOGIRISIM_ALT = `${COMPANY_INFO.legalName} adına T.C. Sanayi ve Teknoloji Bakanlığı tarafından düzenlenen Teknogirişim Rozeti belgesi`;

export const TEKNOGIRISIM_SUMMARY =
  "Katip Otomasyonu'nu geliştiren şirketimiz, T.C. Sanayi ve Teknoloji Bakanlığı tarafından Teknoloji ve Yenilik Odaklı Girişimlerin Belirlenmesi ve Belgelendirilmesine Dair Yönetmelik kapsamında Teknogirişim Rozeti ile belgelendirilmiştir.";

// İstanbul günü (YYYY-MM-DD). `toISOString()` gece yarısı civarında UTC'ye kayardı.
const istanbulToday = () =>
  new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Istanbul' }).format(new Date());

export const isTeknogirisimValid = () => istanbulToday() <= TEKNOGIRISIM.validUntil;
